
module dg.lists {

    import ListQuery = dg.domain.queries.ListQuery;
          
    class SelectedFiltersController {

        public constructor(
            private $document: ng.IDocumentService
        ) {
        }

        private queryManipulator: dg.actions.ServerQueryManipulator;
        public get query() {
            return this.queryManipulator.query;
        }
        public exclude: Array<string> = ['pageNumber', 'pageSize', 'pattern'];
        public include: Array<string>;
        
        $onInit = () => {
            //TODO: to be debugged
            this.include = Object.keys(this.query.dgMeta.properties).filter((el) => {
                return this.exclude.indexOf(el) == -1;
            });

            //Object.keys(myObj).sort((a,b) => myObj[a]-myObj[b])
            //Object
            //    .keys(myObj)
            //    .sort((a, b) => myObj[a] - myObj[b])
            //    .reduce((_sortedObj, key) => ({
            //        ..._sortedObj,
            //        [key]: myObj[key]
            //    }), {})
        }

        public isFilterRequired(selectedFilter) {
            let propExt = this.query.dgMeta.properties[selectedFilter].extensions;

            let result = false;
            if (propExt && propExt.validation) {
                result = propExt.validation.rules[0].type === 'notNull';
            }

            return result;
        }

        public isFilterReadOnly(selectedFilter) {
            return this.query.dgMeta.properties[selectedFilter].readOnly;
        }

        public removeFilter = (filterId: string) => {
            Object.keys(this.query.dgMeta.properties).forEach((propId) => {
                if (propId == filterId) {
                    this.query[propId] = null;
                    return false;
                }
            });
            this.queryManipulator.executeQuery();
        }
    }

    angular.module('dg.lists').component('selectedFilters', {
        bindings: {
            queryManipulator: '<'
        },
        controller: SelectedFiltersController,
        templateUrl: '/digmo/src/lists/selected-filters.html'
    });
}